$(document).on("click" , ".block_similar-product" , function(){     
    let dataUrl = `/recommendations/products/?section_id=related-products&${$(this).attr("data-url")}&limit=10`;    
    $.ajax({
        url: dataUrl,
        type: 'GET',
        dataType: 'html',
        success:function(carthtml) {
            $(".block_similar-products-popup-inner-products").html(carthtml);
            $(".block_similar-products-popup").removeClass("hidden");
            $("body").addClass("overflow-hidden");

           if(!$(".block_relate-slider").hasClass("slick-initialized")){
            $('.block_relate-slider').slick({
                dots: false,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                prevArrow: $('.block_rel-left'),
                nextArrow: $('.block_rel-right'),
                responsive: [
                  {
                    breakpoint: 1201,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  },
                  {
                    breakpoint: 750,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      centerPadding: '50px',
                      infinite: true
                    }
                  },
                  {
                    breakpoint: 420,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      infinite: true,
                      centerPadding: '50px'
                    }
                  }
                ]
              });
           }
             
        }
        });    
  })
  
  $(document).on("click" , ".block_similar-products-popup-inner-close" , function(){
    $(".block_similar-products-popup").addClass("hidden");
     $(".block_similar-products-popup-inner-products").html("")
     $("body").removeClass("overflow-hidden")
  })

$(document).on('click', 'body', function(e){
    var target = e.target;
      if($(".block_similar-products-popup-inner").is(e.target)){
        $('.block_similar-products-popup-inner-close').trigger("click");
    }
});